import { CheckCircleFilled, ClockCircleFilled, PauseCircleFilled } from '@ant-design/icons'
import { Col, Row, theme } from 'antd'
import { FC } from 'react'
import Stamp from '../../../../../types/api/stamp'
import renderDate from '../../../../../helpers/tables/render-date'
import renderDatetime from '../../../../../helpers/tables/render-datetime'

interface StampInfoProps {
    stamp?: Stamp | null
}

const StampInfo: FC<StampInfoProps> = ({ stamp }) => {
    const { token } = theme.useToken()
    const lastOrder = stamp?.last_order

    return (
        <Row gutter={12}>
            <Col style={{ width: 120 }}>Штамп </Col>
            <Col>
                {!lastOrder ? (
                    <>
                        <PauseCircleFilled style={{ color: token.yellow5 }} /> Не заказан
                    </>
                ) : lastOrder.orderStatus === 'Завершен' ? (
                    <>
                        <CheckCircleFilled style={{ color: token.green5 }} /> В наличии
                    </>
                ) : lastOrder.orderStatus === 'Создан' ? (
                    <>
                        <ClockCircleFilled style={{ color: token.blue5 }} /> Создан
                        {lastOrder.estimatedDate
                            ? `. Дата поставки ${renderDate(lastOrder.estimatedDate)}`
                            : null}
                    </>
                ) : (
                    <>
                        <ClockCircleFilled style={{ color: token.blue5 }} /> Заказ:{' '}
                        {lastOrder.orderStatus}. Ожидается {renderDatetime(lastOrder.estimatedDate)}
                    </>
                )}
            </Col>
        </Row>
    )
}

export default StampInfo
